export var FUNDING_STATUS;
(function (FUNDING_STATUS) {
    FUNDING_STATUS["PENDING"] = "PENDING";
    FUNDING_STATUS["ACTIVE"] = "ACTIVE";
    FUNDING_STATUS["CLOSED"] = "CLOSED";
})(FUNDING_STATUS || (FUNDING_STATUS = {}));
export var FUNDING_TRANSACTION_STATUS;
(function (FUNDING_TRANSACTION_STATUS) {
    FUNDING_TRANSACTION_STATUS["DRAFT"] = "DRAFT";
    FUNDING_TRANSACTION_STATUS["PENDING"] = "PENDING";
    FUNDING_TRANSACTION_STATUS["APPROVED"] = "APPROVED";
    FUNDING_TRANSACTION_STATUS["DENIED"] = "DENIED";
})(FUNDING_TRANSACTION_STATUS || (FUNDING_TRANSACTION_STATUS = {}));
export var FUNDING_TRANSACTION_TYPE;
(function (FUNDING_TRANSACTION_TYPE) {
    /** Inflow (e.g., adding grant money) */
    FUNDING_TRANSACTION_TYPE["CREDIT"] = "CREDIT";
    /** Outflow (e.g., spending on a case) */
    FUNDING_TRANSACTION_TYPE["DEBIT"] = "DEBIT";
})(FUNDING_TRANSACTION_TYPE || (FUNDING_TRANSACTION_TYPE = {}));
//# sourceMappingURL=funding.js.map